<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DK824E/tc-custom/9781398441019.jpg?1682168952798" alt="This image is the cover for the book The Chinese Stone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Chinese Stone
      </h1>
      <p class="bookDescription body article font2">
        <p>Howard Wu’s insatiable greed puts the secret mountain villages at risk, and it must be stopped. Amid the bustling crowds of downtown, Choi An thinks he’s safe. But as he navigates the throngs of people, a sudden stab to his heart takes him by surprise. Without a sound, he falls to the ground, the victim of a ruthless attack. Follow the twists and turns of The Chinese Stone as the fight for power and control of a valuable resource unfolds in this action-packed thriller.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Van
      </h2>
      
      <p class="authorDescription body article">Van was born in 1950; did his national service in Pretoria; worked at Western Province Sports Club for eighteen years and began travelling in the late eighties; back packing through Asia and Western Europe. Finally settling in Britain where he began writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b9ad128